/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_NumberInputs */

const th_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หมายเลขเสื้อ`)
};

const en_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squad number`)
};

const ja_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背番号`)
};

const zh_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球衣号码`)
};

const es_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dorsal`)
};

const pt_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número da camisa`)
};

const id_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor punggung`)
};

const fr_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de maillot`)
};

const tl_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero ng damit`)
};

const vi_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số áo`)
};

const ko_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등번호`)
};

const de_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trikotnummer`)
};

const ru_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игровой номер`)
};

const tr_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma numarası`)
};

const it_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di maglia`)
};

const pl_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numer na koszulce`)
};

const uk_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігровий номер`)
};

const hi_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जर्सी नंबर`)
};

const ar_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقم القميص`)
};

const ms_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombor jersi`)
};

const bn_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জার্সি নম্বর`)
};

const zh_tw2_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球衣號碼`)
};

const zh_hk2_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球衣號碼`)
};

const ur_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شرٹ نمبر`)
};

const fa_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شمارهٔ پیراهن`)
};

const sw_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namba ya jezi`)
};

const nl_player_number = /** @type {(inputs: Player_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rugnummer`)
};

/**
* | output |
* | --- |
* | "Squad number" |
*
* @param {Player_NumberInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_number = /** @type {((inputs?: Player_NumberInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_NumberInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_number(inputs)
	if (locale === "ja") return ja_player_number(inputs)
	if (locale === "zh") return zh_player_number(inputs)
	if (locale === "es") return es_player_number(inputs)
	if (locale === "pt") return pt_player_number(inputs)
	if (locale === "id") return id_player_number(inputs)
	if (locale === "fr") return fr_player_number(inputs)
	if (locale === "tl") return tl_player_number(inputs)
	if (locale === "vi") return vi_player_number(inputs)
	if (locale === "ko") return ko_player_number(inputs)
	if (locale === "de") return de_player_number(inputs)
	if (locale === "ru") return ru_player_number(inputs)
	if (locale === "tr") return tr_player_number(inputs)
	if (locale === "it") return it_player_number(inputs)
	if (locale === "pl") return pl_player_number(inputs)
	if (locale === "uk") return uk_player_number(inputs)
	if (locale === "hi") return hi_player_number(inputs)
	if (locale === "ar") return ar_player_number(inputs)
	if (locale === "ms") return ms_player_number(inputs)
	if (locale === "bn") return bn_player_number(inputs)
	if (locale === "zh-TW") return zh_tw2_player_number(inputs)
	if (locale === "zh-HK") return zh_hk2_player_number(inputs)
	if (locale === "ur") return ur_player_number(inputs)
	if (locale === "fa") return fa_player_number(inputs)
	if (locale === "sw") return sw_player_number(inputs)
	if (locale === "nl") return nl_player_number(inputs)
	return en_player_number(inputs)
});